import React from "react";

import { wikiArticleUrl } from "@/mk2/apps/wiki/utils";
import { ImgCropMode, ImgCropped } from "@/mk2/components/ImgCropped";
import { Link } from "@/mk2/components/Link";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { getBestVersionForThumb } from "@/mk2/decorators/withUploader";
import { LoadingState } from "@/mk2/reducers/loadingState";
import { WikiArticleEntity } from "@/mk2/schemas";
import { upperCaseFirst } from "@/mk/bazaar/common/filters";
import { photoUrl } from "@/mk/photo/photoUrl";

import styles from "./Thumbnail.mscss";

interface OwnProps {
    articleSlug: string;
    categorySlug: string;
    article: WikiArticleEntity;
    loadingState: LoadingState;
    onLoad(articleSlug: string, categorySlug: string);
}

type Props = OwnProps;

class Thumbnail extends React.Component<Props> {
    public render() {
        const { article, articleSlug, categorySlug, loadingState } = this.props;
        return (
            <div className={styles.Thumbnail}>
                {articleSlug && categorySlug ? (
                    <LoadingSwitch
                        loadingState={loadingState}
                        onLoad={this.load}
                        onRenderSuccess={this.renderSuccess}
                        hasData={!!article}
                    />
                ) : (
                    this.renderSuccess()
                )}
            </div>
        );
    }

    public renderSuccess = () => {
        const { article } = this.props;
        const photo = article?.photos?.length > 0 ? article.photos[0] : null;

        return (
            <>
                <div className={styles.Thumbnail__image}>
                    {photo ? (
                        <ImgCropped
                            className={styles.Thumbnail__image__img}
                            width={64}
                            height={64}
                            mode={ImgCropMode.Cover}
                            imgUrl={photoUrl(photo, getBestVersionForThumb(photo))}
                            imgWidth={photo.width}
                            imgHeight={photo.height}
                            lazy
                        />
                    ) : (
                        <div className={styles.Thumbnail__image__placeholder} />
                    )}
                </div>
                <div className={styles.Thumbnail__rightColumn}>
                    <div>
                        <Link to={wikiArticleUrl(article)}>{upperCaseFirst(article.title)}</Link>
                    </div>
                </div>
            </>
        );
    };

    private load = () => {
        const { articleSlug, categorySlug, onLoad } = this.props;
        if (articleSlug && categorySlug) {
            onLoad(articleSlug, categorySlug);
        }
    };
}

export default Thumbnail;
